export const version = '0.745.0'
export const chameleonWebVersion = '8.8.1'
export const chameleonCoreVersion = '7.6.0'
